import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import classNames from 'fg-frontend/src/lib/classNames';
import Glide from '@glidejs/glide';

const fragments = {
  SLIDER: '[data-fragment="InspirationWidget.slider"]',
  ITEM: '[data-fragment="InspirationWidget.item"]',
  BG_WRAPPER: '[data-fragment="InspirationWidget.bgWrapper"]',
};

class InspirationWidget extends WebComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentBg: null,
      itemHover: false,
    };
    this.hover = this.hover.bind(this);
    this.switchBg = this.switchBg.bind(this);
    this.switchBgBack = this.switchBgBack.bind(this);
    this.createBackgrounds = this.createBackgrounds.bind(this);
  }
  didMount() {
    if (window.innerWidth < 768) {
      this.slider = this.element.querySelector(fragments.SLIDER);
      new Glide(this.slider, InspirationWidget.defaultProps).mount();
    } else {
      this.bgWrapper = this.element.querySelector(fragments.BG_WRAPPER);
      this.items = [...this.element.querySelectorAll(fragments.ITEM)];
      for (let i = 0; i < this.items.length; i++) {
        this.items[i].addEventListener('mouseenter', this.switchBg);
        this.items[i].addEventListener('mouseleave', this.switchBgBack);
      }
      this.createBackgrounds();
    }
    this.on('click', fragments.ITEM, this.hover);
  }
  createBackgrounds = () => {
    let html = '';
    this.bgIds = [];
    for (let i = 0; i < this.items.length; i++) {
      const id = `bg-${i}`;
      this.items[i].setAttribute('data-id', id);
      html = `${html}<img src="${this.items[i].dataset.bg}" class="inspiration-widget__bg inspiration-widget__bg--hidden" id="${id}" />`;
      this.bgIds.push(id);
    }
    this.bgWrapper.innerHTML += html;
  };
  hover = (e) => {
    e.currentTarget.classList.toggle('hover');
  };
  switchBg = (e) => {
    const currentId = e.currentTarget.dataset.id;
    if (currentId !== this.state.currentBg) {
      const el = document.getElementById(currentId);
      for (let i = 0; i < this.bgIds.length; i++) {
        let el = document.getElementById(this.bgIds[i]);
        el.classList.add('inspiration-widget__bg--hidden');
      }
      el.classList.remove('inspiration-widget__bg--hidden');
      this.setState({
        currentBg: currentId,
        itemHover: true,
      });
    }
  };
  switchBgBack = (e) => {
    const el = document.getElementById(e.currentTarget.dataset.id);
    el.classList.add('inspiration-widget__bg--hidden');
    this.setState({
      currentBg: null,
      itemHover: false,
    });
  };
  willUnMount() {}
  update() {
    const { itemHover } = this.state;
    if (window.innerWidth >= 768) {
      classNames(this.bgWrapper, { 'inspiration-widget__bg-wrapper--item-hover': itemHover });
    }
  }
}

InspirationWidget.defaultProps = {
  gap: 0,
};

export default InspirationWidget;



// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/InspirationWidget.js